// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LOCAL_API_URL_OVERRIDE } from './local-api-override';

export const environment = {
  production: false,
  /** Bake-in via `npm run start:local-api -- --api-port=3032` (null = context apiAddress). */
  localApiUrl: LOCAL_API_URL_OVERRIDE as string | null,
  firebase: {
    apiKey: 'xx',
    authDomain: 'proc-cert.firebaseapp.com',
    databaseURL: 'https://proc-cert.firebaseio.com',
    projectId: 'proc-cert',
    storageBucket: 'proc-cert.appspot.com',
    messagingSenderId: '706214752101'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
